module.exports = __webpack_public_path__ + "img/Rios.b1ce35c3.jpg";